<template>
  <div
    class="msg-face"
  >
    <span v-html="processedFace"></span>
  </div>
</template>

<script>
import Utils from '@/utils/string';

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      selectedText: '',
    };
  },
  computed: {
    processedFace() {
      const text = Utils.faceTipEscape(this.data.index);
      return text || this.data.content;
    },
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.msg-face {
  font-family: @emoji-family, "PingFangSC-Regular", "Microsoft YaHei",
    "sans-serif";
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 10px 15px;
  max-width: 300px;

  .emoji {
    font-size: 20px;
    vertical-align: -2px;
  }

  &.pc{
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    max-width: 750px;
  }
  &.pc.pc-not-frame{
    padding: 12px;
    font-size: 15px;
    line-height: 21px;
    .emoji {
      font-size: 21px;
    }
  }
}

@media (min-width: 600px) {
  .im-in-frame {
    .msg-face.pc{
      max-width: 460px;
    }
  }
}
@media (min-width: 800px) {
  .im-in-frame {
    .msg-face.pc{
      max-width: 600px;
    }
  }
}
</style>
